<template>
  <div>
    <div style="background: linear-gradient(45deg, #28a745, #20c997)">
      <layouts-header />

      <!-- breadcrumb-bar -->
      <div class="breadcrumb-bar bg-transparent">
        <div class="container">
          <div class="row align-items-center text-center col-md-12 col-12">
            <h2 class="breadcrumb-title">السيارات المفضلة لديك</h2>
          </div>
        </div>
      </div>
    </div>
    <!-- /breadcrumb-bar -->

    <section class="section car-listing pt-0">
      <div class="container">
        <div class="row">
          <div>
            <!-- loading -->
            <div
              v-if="favoriteStore.isLoading"
              class="d-flex justify-content-center align-items-center"
              style="min-height: 60vh; width: 100%"
            >
              <a-spin size="large" tip="جاري التحميل..." />
            </div>
            <!-- No data-->
            <div
              v-else-if="!favoriteStore.myCars.length"
              class="w-100 text-center mt-10"
              style="margin-top: 60px !important"
            >
              <p class="fs-4 fw-bold text-dark">
                🚗 لا توجد سيارات مفضلة لديك حاليا
              </p>
            </div>

            <!-- Cars Grid -->
            <div class="row" v-else>
              <div
                class="col-lg-4 col-md-6 col-12"
                v-for="item in paginatedCars"
                :key="item.id"
                data-aos="fade-down"
              >
                <div class="listing-item bike-list my-4">
                  <div class="listing-img">
                    <router-link :to="`/listing/${item.id}`">
                      <img
                        :src="
                          item.images[0]?.image ||
                          require('@/assets/img/cars/no-car.jpg')
                        "
                        class="img-fluid"
                        alt="car"
                      />
                    </router-link>
                  </div>
                  <div class="listing-content">
                    <div
                      class="listing-features d-flex justify-content-between"
                    >
                      <div class="list-rating">
                        <!-- مفيش تقييمات في الريسبونس، ممكن نشيلهم أو نعمل قيمة افتراضية -->
                        <!-- <div class="list-ratings">
                          <i class="fas fa-star filled me-1"></i>
                          <i class="fas fa-star filled me-1"></i>
                          <i class="fas fa-star filled me-1"></i>
                          <i class="fas fa-star filled me-1"></i>
                          <i class="fas fa-star"></i>
                          <span>0</span>
                        </div> -->
                        <div>
                          <span class="featured-text">{{
                            timeAgo(item.created_at)
                          }}</span>
                        </div>
                        <span class="featured-text"
                          >{{ item.brand?.name }} - {{ item.model?.name }}</span
                        >
                      </div>
                      <div class="list-km">
                        <span class="km-count"
                          ><img
                            src="@/assets/img/icons/map-pin.svg"
                            alt="author"
                          />{{ item.city?.name }} - {{ item.district?.name }}
                        </span>
                      </div>
                    </div>
                    <div class="listing-details-group">
                      <ul>
                        <li>
                          <span
                            ><img
                              src="@/assets/img/icons/car-parts-05.svg"
                              alt="Manual"
                          /></span>
                          <p>&nbsp; {{ item.gear }}</p>
                        </li>
                        <li>
                          <span
                            ><img
                              src="@/assets/img/icons/car-parts-02.svg"
                              alt="18 KM"
                          /></span>
                          <p>&nbsp; {{ item.kilometers }}</p>
                        </li>
                        <li>
                          <span
                            ><img
                              src="@/assets/img/icons/car-parts-03.svg"
                              alt="Diesel"
                          /></span>
                          <p>&nbsp; {{ item.fuel_type }}</p>
                        </li>

                        <li>
                          <span
                            ><img
                              src="@/assets/img/icons/car-parts-05.svg"
                              alt="2018"
                          /></span>
                          <p>&nbsp; {{ item.year }}</p>
                        </li>
                      </ul>
                    </div>
                    <div class="listing-button">
                      <!-- <div class="listing-price">
                        <h6>{{ item.price }} <span>جنيه</span></h6>
                      </div> -->
                      <div class="listing-price">
                        <h6 v-if="item.rent_or_sale == 'rent'">
                          ${{ item.price?.daily }}
                          <span>/ يوم</span>
                        </h6>
                        <h6 v-else-if="item.rent_or_sale == 'installment'">
                          ${{ item.installment?.price }}
                        </h6>
                        <h6 v-else>${{ item.price }}</h6>
                      </div>
                      <div class="d-flex align-items-center">
                        <a
                          href="javascript:void(0)"
                          class="fav-icon"
                          @click="toggleSelected(item)"
                          :class="{ selected: item.is_fav }"
                        >
                          <i class="feather-heart"></i>
                        </a>
                        <router-link
                          :to="`/listing/${item.id}`"
                          class="btn btn-order"
                          >شوف تفاصيل</router-link
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Pagination Controls -->
            <div
              class="d-flex justify-content-center mt-4"
              v-if="totalPages > 1"
            >
              <button
                class="btn btn-outline-primary mx-2"
                :disabled="currentPage === 1"
                @click="prevPage"
              >
                السابق
              </button>

              <span class="align-self-center"
                >صفحة {{ currentPage }} من {{ totalPages }}</span
              >

              <button
                class="btn btn-outline-primary mx-2"
                :disabled="currentPage === totalPages"
                @click="nextPage"
              >
                التالي
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>

    <layout-footer />
  </div>
</template>

<script>
import { Carousel, Pagination, Navigation, Slide } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";
import { useFavoriteStore } from "@/stores/favorite";

export default {
  setup() {
    const favoriteStore = useFavoriteStore();
    favoriteStore.getFavoriteCars();

    return { favoriteStore };
  },
  data() {
    return {
      settings: { itemsToShow: 1, snapAlign: "center" },
      breakpoints: {
        575: { itemsToShow: 1, snapAlign: "center" },
        767: { itemsToShow: 1, snapAlign: "center" },
        991: { itemsToShow: 1, snapAlign: "center" },
        1024: { itemsToShow: 1, snapAlign: "start" },
      },
      // Pagination
      currentPage: 1,
      itemsPerPage: 6,
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.favoriteStore.myCars.length / this.itemsPerPage);
    },
    paginatedCars() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.favoriteStore.myCars.slice(start, end);
    },
  },
  methods: {
    timeAgo(date) {
      if (!date) return "";
      const now = new Date();
      const created = new Date(date);
      const diff = Math.floor((now - created) / 1000);

      if (diff < 60) return "منذ ثوانٍ";
      if (diff < 3600) return `منذ ${Math.floor(diff / 60)} دقيقة`;
      if (diff < 86400) return `منذ ${Math.floor(diff / 3600)} ساعة`;
      if (diff < 2592000) return `منذ ${Math.floor(diff / 86400)} يوم`;
      if (diff < 31104000) return `منذ ${Math.floor(diff / 2592000)} شهر`;
      return `منذ ${Math.floor(diff / 31104000)} سنة`;
    },
    toggleSelected(item) {
      this.favoriteStore.toggleFavorite(item.id);

      item.isSelected = !item.isSelected;
      item.is_fav = !item.is_fav;
    },
    nextPage() {
      if (this.currentPage < this.totalPages) this.currentPage++;
    },
    prevPage() {
      if (this.currentPage > 1) this.currentPage--;
    },
  },
  components: { Carousel, Slide, Pagination, Navigation },
};
</script>

<style scoped>
.listing-img img {
  width: 100%;
  height: 220px;
  object-fit: cover;
  border-radius: 8px;
}
</style>
